export const BASE_URL = 'https://www.reddit.com'
